export class FileType {
    ID: number;
    Name: string;
}

export default FileType;